import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/works', label: 'Works' },
    { path: '/about', label: 'About' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/installations', label: 'Installations' },
    { path: '/store', label: 'Store' },
    { path: '/commissions', label: 'Commissions' },
    { path: '/collect', label: 'Collect' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-off-black/95 backdrop-blur-sm border-b border-deep-charcoal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className="text-base sm:text-lg font-serif text-soft-ivory tracking-wide hover:opacity-60 transition-opacity duration-400"
          >
            Leigh Witherell
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8 xl:gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-widest uppercase transition-colors duration-400 ${
                  isActive(link.path)
                    ? 'text-soft-ivory'
                    : 'text-soft-ivory/80 hover:text-soft-ivory'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-soft-ivory p-2 hover:bg-zinc-800 rounded transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-zinc-800 pt-4">
            <div className="space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`block text-sm tracking-widest uppercase py-3 px-4 rounded transition-colors ${
                    isActive(link.path)
                      ? 'text-soft-ivory bg-zinc-800'
                      : 'text-soft-ivory/80 hover:text-soft-ivory hover:bg-zinc-800/50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
